import { pagingSettings } from '../../../utils/GridPagingUtils';
import GeneralCompetencyEventListPageActionTypes from '../actions/general-competency-event-list-page-action-types';

const initialState = {
  loading: false,
  generalCompetencyEvents: null,
  cancelToken: null,
  skip: pagingSettings.paging.skip,
  take: pagingSettings.paging.take,
  total: 0,
  filter: null,
  canWrite: false,
  sorting: null,
  isConfirmDialogVisible: false,
  selectedEventId: null,
  generalCompetencyEventStatuses: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GeneralCompetencyEventListPageActionTypes.LOAD_GENERAL_COMPETENCY_EVENT_LIST_START:
      return {
        ...state,
        loading: true
      };
    case GeneralCompetencyEventListPageActionTypes.LOAD_GENERAL_COMPETENCY_EVENT_LIST_END:
      return {
        ...state,
        loading: false,
        generalCompetencyEvents: action.payload?.generalCompetencyEvents,
        total: action.payload?.total,
        skip: action.payload?.skip,
        take: action.payload?.take,
        canWrite: action.payload?.canWrite
      };
    case GeneralCompetencyEventListPageActionTypes.FILTER_GENERAL_COMPETENCY_EVENT_LIST:
      return {
        ...state,
        filter: action.payload,
        skip: initialState.skip,
        take: initialState.take
      };
    case GeneralCompetencyEventListPageActionTypes.TOGGLE_GENERAL_COMPETENCY_EVENT_LIST_CONFIRM_DIALOG:
      return {
        ...state,
        selectedEventId: action.payload?.id ?? null,
        isConfirmDialogVisible: !!action.payload,
        confirmDialogErrorMessage: null
      };
    case GeneralCompetencyEventListPageActionTypes.SET_CONFIRM_DIALOG_ERROR:
      return {
        ...state,
        confirmDialogErrorMessage: action.payload?.errorMessage
      };
    case GeneralCompetencyEventListPageActionTypes.SORT_GENERAL_COMPETENCY_EVENT_LIST:
      return {
        ...state,
        sorting: action.payload
      };
    case GeneralCompetencyEventListPageActionTypes.LOAD_GENERAL_COMPETENCY_EVENT_LIST_STATUSES:
      return {
        ...state,
        generalCompetencyEventStatuses: action.payload?.statuses ?? []
      };
    default:
      return state;
  }
};
